import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import TopPanel from '@components/operatorPanel/components/OperatorPanelInformation/TopPanel';
import AddButtonWithHover from '@components/operatorPanel/components/elements/buttons/AddButtonWithHover';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import NCFileList from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationNcFilesScreen/NCFileList';
import Loading from '@components/loading';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { WithColor } from '@styles/colors';
import { ToolsTable } from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationToolsScreen/ToolsTable';
import { useManageOperatorPanelInformationToolsScreen } from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationToolsScreen/hooks/useManageOperatorPanelInformationToolsScreen';

export interface OperatorPanelInformationToolsScreenProps extends WithColor {
  isWithERP: boolean;
}

const OperatorPanelInformationToolsScreen = ({ C, isWithERP }: OperatorPanelInformationToolsScreenProps) => {
  const { bg, isLoading, currentNCFile, isAllMode, ncFileListProps, tools, toolsTableConfig, handleAddTool, goToToolDetails } =
    useManageOperatorPanelInformationToolsScreen({ C });

  if (isLoading) {
    return <Loading background={bg} />;
  }

  return (
    <View testID={TEST_IDS.operatorPanel.information.tools.root} style={{ backgroundColor: bg, flex: 1 }}>
      <TopPanel title="Tools" withBottomBorder={!currentNCFile} submit={() => {}}>
        {currentNCFile && !isAllMode && <AddButtonWithHover C={C} scale={scaleOP} onPress={handleAddTool} />}
      </TopPanel>
      {currentNCFile ? (
        <View style={{ paddingHorizontal: scaleOP(24), flex: 1 }}>
          <NCFileList withERP={isWithERP} C={C} scale={scaleOP} font={fontOP} showAllButton showAllButtonIfNoMain {...ncFileListProps} />
          <View style={{ marginTop: scaleOP(24), marginBottom: scaleOP(18), height: '100%', flex: 'auto' }}>
            <ToolsTable data={tools} config={toolsTableConfig} onPress={goToToolDetails} C={C} maxHeight="auto" />
          </View>
        </View>
      ) : (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Text style={[fontOP['Body'], { color: C('Label/Light/Tertiary') }]}>{i18n.t('Add an NC file to this Job before adding tools.')}</Text>
        </View>
      )}
    </View>
  );
};

export default OperatorPanelInformationToolsScreen;
